// JOBE-0106: DecideTodayLane — UI mock per Decision 3 of the spec.
//
// Static placeholder rows with action-class badges. The vocabulary
// `Approve` / `Decide` / `Review` / `Reply` is the wireframe copy
// verbatim; these are presentation tokens, NOT a backend enum.

import React from 'react';

const DECIDE_ROWS = [
  { id: 'd1', cls: 'approve', label: 'Approve', title: 'Q2 hiring plan revision' },
  { id: 'd2', cls: 'decide', label: 'Decide', title: 'Vendor selection · datastore tier' },
  { id: 'd3', cls: 'review', label: 'Review', title: 'Brief: routing-overlay refresh' },
  { id: 'd4', cls: 'reply', label: 'Reply', title: 'Customer note · contract renewal' },
];

export function DecideTodayLane() {
  return (
    <section
      className="project-decide-today decide"
      data-testid="decide-today-lane"
      aria-label="Decide today"
    >
      <header className="lane-header">
        <h3 className="lane-title">Decide today</h3>
        <span className="lane-preview-marker mono">preview</span>
      </header>
      <ul className="decide-rows">
        {DECIDE_ROWS.map((r) => (
          <li key={r.id} className="row decide-row" data-action-class={r.cls}>
            <span
              className={`badge ${r.cls}`}
              data-testid={`decide-badge-${r.cls}`}
            >
              {r.label}
            </span>
            <span className="decide-title">{r.title}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
